import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
};

const ErrorText = styled('p')<Props>({
  fontSize: '1.2rem',
  fontWeight: 'bold',
  lineHeight: 1.4,
  marginBottom: '0.8rem',
});

export default ErrorText;
